import React from 'react';

const portrait = ( props ) => (
	<div className="Person">
		<img src={ props.image } alt={ props.name } />
		<p className="person-name">{ props.name }</p>
		<p className="person-position">{ props.position }</p>
		<p className="person-location">{ props.location }</p>
	</div>
);

export default portrait;



// WEBPACK FOOTER //
// ./src/components/Portraits/Portrait.js